import React from "react";
import "./infos_cards_view.css";
import CardsInfoHome from "../../../core/components/cards/card_info_home/card_info_home.jsx";
import { infosCardsMapper } from "../utils/mapper/infos_cards_mapper.jsx";
import { useInfosCardsViewModel } from "../view_model/infos_cards_view_model.jsx";

const InfosCardsView = () => {
    const { cards: cardData } = infosCardsMapper;
    const { cards, sectionRef } = useInfosCardsViewModel();

    return (
        <div className="infos_cards" ref={sectionRef}>
            <div className="row container">
                {cardData.map((card, index) => (
                    <div key={index} className="col-3">
                        <CardsInfoHome
                            title={card.title}
                            description={card.description}
                            isVisible={cards[index]}
                            delay={index}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InfosCardsView;
